<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Items" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <b-row>
          <b-col cols="10">
            <h2 class="mb-2">Items List</h2>
          </b-col>
          <b-col cols="2">
            <div class="text-center">
              <items-create-form 
                :display_order="total_items"
                @create="createItem"
              />
            </div>
          </b-col>
        </b-row>
      </section>
    </b-media>
    <b-card>
      <items-table 
        @getList="getList"
        @clearFilter="clearFilter"
        :items="items"
      />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_perpage"
    />
  </div>
</template>
<script>
import service from '../service'
import ItemsTable from './_components/ItemsTable.vue'
import ItemsCreateForm from './_components/ItemsCreateForm.vue'
export default {
  components: {
    ItemsTable,
    ItemsCreateForm
  },
  data(){
    return {
      current_page: 1,
      total_items: 0,
      items_perpage: 15,
      items: [],
      editLanguage: null,
      filter: {}
    }
  },
  watch:{
    current_page() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList(filter) {
      this.filter = filter ? filter : this.filter
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_perpage,
        query: JSON.stringify(this.filter)
      });
      if (response.data.type === "DATA") {
        this.items = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },
    createItem(){
      this.getList();
    },
    clearFilter(){
      this.filter = {};
      this.getList()
    }
  },
}
</script>